// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__1HfJ-","logo":"Navbar_logo__ug_XO","navBtn":"Navbar_navBtn__2PkGT"};